import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ClickOutsideModule } from '../../../../shared';

import { NumberToAlphabetPipe } from './number-to-alphabet.pipe';
import { QuestionTableCheckboxComponent } from './question-table-checkbox.component';
import { CheckboxTableComponent } from './table/checkbox-table.component';
import { HelperCellComponent } from './table/helper-cell/helper-cell.component';
import { HeaderCellComponent } from './table/header-cell/header-cell.component';
import { RegularCellComponent } from './table/regular-cell/regular-cell.component';
import { RangeDropdownXComponent } from './table/range-dropdown-x/range-dropdown-x.component';
import { RangeDropdownYComponent } from './table/range-dropdown-y/range-dropdown-y.component';

@NgModule({
  imports: [
    QuestionModule,
    ClickOutsideModule,
    BsDropdownModule.forRoot(),
  ],
  declarations: [ QuestionTableCheckboxComponent, CheckboxTableComponent,  NumberToAlphabetPipe, HelperCellComponent, HeaderCellComponent, RegularCellComponent, RangeDropdownXComponent, RangeDropdownYComponent ],
  exports:[QuestionTableCheckboxComponent]
})
export class QuestionTableCheckboxModule { }

